import { memo, useState } from "react";

const SESSION_KEY = "AppDownloadPromptDismissed";

const AppDownloadPrompt = () => {
    const [visible, setVisible] = useState(() => {
        // Show only if not dismissed this session
        return sessionStorage.getItem(SESSION_KEY) !== "true";
    });

    const handleClose = () => {
        sessionStorage.setItem(SESSION_KEY, "true");
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <>
            {visible &&
                <div className="strNtf">
                    <button className="btn strNtfCls" onClick={() => { handleClose() }}>
                        <span className="crIcs v2">
                            <img className="img-fluid"
                                src={require("../../../assets/images/inner/circle-outer.svg").default} alt="circle-outer"
                                width={60} />
                            <img className="img-fluid"
                                src={require("../../../assets/images/inner/circle-inner.svg").default} alt="circle-inner"
                                width={60} />
                            <span className="crIc">
                                <img src={require("../../../assets/icons/close.svg").default} alt="close" />
                            </span>
                        </span>
                    </button>
                    <div className="shps">
                        <div className="prfRvnBg1"></div>
                        <div className="prfRvnBg2"></div>
                        <div className="prfRvnSh5"></div>
                        <div className="prfRvnSh6"></div>
                        <div className="prfRvnSh1"></div>
                        <div className="prfRvnSh2"></div>
                        <div className="prfRvnSh3"></div>
                        <div className="prfRvnSh4">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                    <div className="strNtfHd">Continue with our app</div>
                    <div className="strNtfBd">
                        <div className="strNtfRw">
                            <a href="https://play.google.com/store/apps/details?id=com.application.quantatra&hl=en" target="_blank"
                                rel="noopener noreferrer">
                                <img src={require("../../../assets/images/stores/play-store.png")}
                                    alt="Get it on Google Play" />
                            </a>
                            <a href="https://apps.apple.com/us/app/quantara-app/id6795036310" target="_blank" rel="noopener noreferrer">
                                <img src={require("../../../assets/images/stores/apple-store.svg").default}
                                    alt="Download on the App Store" />
                            </a>
                        </div>
                    </div>
                </div>
            }

        </>
    );
};

export default memo(AppDownloadPrompt);